export default [
	{
		type: "special",
		id: 1,
		items: [
			{
				id: 1,
				text: "Is there a class schedule or curriculum for the course?",
				label: [
					{
						id: 1,
						text: "Yes",
					},
					{
						id: 2,
						text: "No",
					},
					{
						id: 3,
						text: "I don't know",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 2,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 3,
				text: "The punctuality and regularity of the course was good.",
			},
			{
				id: 4,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 5,
				text: "Medical / dental / clinical references were made in the course.",
			},
			{
				id: 6,
				text: "References to current topics were made in the course.",
			},
			{
				id: 7,
				text: "The course is relevant for exams",
			},
			{
				id: 8,
				text: "The quality of the teaching materials and media was good.",
			},
			{
				id: 9,
				text: "Suggestions for in-depth study were provided (e.g., lecture notes, web links).",
			},
			{
				id: 10,
				text: "The quality of the classroom and technical equipment was good.",
			},
			{
				id: 11,
				text: "The lecturer was very competent.",
			},
			{
				id: 12,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 13,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 14,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 15,
				text: "The lecturer repeated the content appropriately.",
			},
			{
				id: 16,
				text: "The lecturer provided the opportunity to discuss the content.",
			},
			{
				id: 17,
				text: "There was good interdisciplinary teaching in the course.",
			},
			{
				id: 18,
				text: "I learned a lot in this course.",
			},
			{
				id: 19,
				text: "Overall, this was a good course.",
			},
			{
				id: 20,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "bi",
		id: 3,
		items: [
			{
				id: 21,
				text: "The difficulty of the content was...",
			},
			{
				id: 22,
				text: "The amount of the content was...",
			},
			{
				id: 23,
				text: "The pace of the course was...",
			},
			{
				id: 24,
				text: "The requirements of the course were...",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 25,
				text: "Further remarks: I especially appreciated",
			},
			{
				id: 26,
				text: "Further remarks: I did not like",
			},
			{
				id: 27,
				text: "Further remarks: Suggestions for improvements",
			},
		],
	},
];
